import { CountryEnum as r } from "./country-enum.mjs";
import n from "i18n-iso-countries";
import { getLanguageCodeByLocale as o } from "../locales/language-utils.mjs";
import { LocaleEnum as c } from "@systemeio/types";
const s = (t, e) => {
  try {
    return new Intl.DisplayNames([t], { type: "region" }).of(e);
  } catch {
    return;
  }
}, i = "Canary Islands", m = (t, e) => {
  const a = o(e);
  switch (t) {
    // Related SC https://app.shortcut.com/systeme/story/15639/change-the-name-of-taiwan-province-of-china-to-taiwan
    case r.Taiwan:
      return n.getName(t, a, { select: "alias" }) ?? t;
    case r.CanaryIslands:
      return s(a, t) ?? i;
    default:
      return n.getName(t, a, { select: "official" }) ?? t;
  }
}, N = (t = c.ENGLISH) => Object.values(r).map((e) => ({
  id: e,
  caption: m(e, t)
}));
export {
  N as getCountryData,
  m as getCountryName
};
